import {
  GET_SURVEYTEMPLATE,
  GET_SURVEYTEMPLATE_SUCCESS,
  GET_SURVEYTEMPLATE_FAIL,
  DELETE_SURVEYTEMPLATE,
  DELETE_SURVEYTEMPLATE_SUCCESS,
  DELETE_SURVEYTEMPLATE_FAIL,
  UPDATE_SURVEYTEMPLATE,
  UPDATE_SURVEYTEMPLATE_SUCCESS,
  UPDATE_SURVEYTEMPLATE_FAIL,
  ADD_NEW_SURVEYTEMPLATE,
  ADD_SURVEYTEMPLATE_SUCCESS,
  ADD_SURVEYTEMPLATE_FAIL,
  SURVEYTEMPLATE_LOADING,
  SURVEYTEMPLATE_RESET,
  SURVEYTEMPLATE_RESET_CREATE,
} from "./actionType";

export const resetSurveyTemplateState = (actionType) => ({
  type: SURVEYTEMPLATE_RESET,
  payload: { actionType },
});

export const resetSurveyTemplateCreateState = (actionType) => ({
  type: SURVEYTEMPLATE_RESET_CREATE,
  payload: { actionType },
});

export const getSurveyTemplateSuccess = (actionType, data) => ({
  type: GET_SURVEYTEMPLATE_SUCCESS,
  payload: { actionType, data },
});

export const getSurveyTemplateFail = (actionType, error) => ({
  type: GET_SURVEYTEMPLATE_FAIL,
  payload: { actionType, error },
});

export const getSurveyTemplate = (data) => ({
  type: GET_SURVEYTEMPLATE,
  payload: data,
});

export const getSurveyTemplateLoading = () => ({
  type: SURVEYTEMPLATE_LOADING,
});

export const deleteSurveyTemplate = (data) => ({
  type: DELETE_SURVEYTEMPLATE,
  payload: data,
});

export const deleteSurveyTemplateSuccess = (data) => ({
  type: DELETE_SURVEYTEMPLATE_SUCCESS,
  payload: data,
});

export const deleteSurveyTemplateFail = (error) => ({
  type: DELETE_SURVEYTEMPLATE_FAIL,
  payload: error,
});

export const updateSurveyTemplate = (data) => ({
  type: UPDATE_SURVEYTEMPLATE,
  payload: data,
});

export const updateSurveyTemplateFail = (error) => ({
  type: UPDATE_SURVEYTEMPLATE_FAIL,
  payload: error,
});

export const updateSurveyTemplateSuccess = (data) => ({
  type: UPDATE_SURVEYTEMPLATE_SUCCESS,
  payload: data,
});

export const addNewSurveyTemplate = (data) => ({
  type: ADD_NEW_SURVEYTEMPLATE,
  payload: data,
});

export const addSurveyTemplateSuccess = (data) => ({
  type: ADD_SURVEYTEMPLATE_SUCCESS,
  payload: data,
});

export const addSurveyTemplateFail = (error) => ({
  type: ADD_SURVEYTEMPLATE_FAIL,
  payload: error,
});
